import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const RoundPick = ({ label, value, rounds, onChange, testId }) => (
  <label className="space-y-1">
    <span className="text-xs text-slate-400">{label}</span>
    <Select key={`${rounds.length}-${value}`} value={value || undefined} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="h-11 bg-[#0A0D14] border-[#26334D]"><SelectValue placeholder="Scegli" /></SelectTrigger>
      <SelectContent className="bg-[#121824] border-[#26334D] max-h-64">
        {rounds.map((r) => <SelectItem key={r.key} value={r.key} data-testid={`${testId}-${r.key}`}>{r.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </label>
);

// fetchRounds(competition) -> Promise<rounds[]>; sets defaults to the first open round and the last round.
export const RoundRangeFields = ({ competition, start, end, onChange, fetchRounds, testPrefix, keepValues }) => {
  const [rounds, setRounds] = useState([]);
  useEffect(() => {
    fetchRounds(competition).then((rs) => {
      setRounds(rs);
      if (keepValues && start) return;
      const first = rs.find((r) => r.status === "open") || rs[0];
      onChange({ start_round: first?.key || null, end_round: rs[rs.length - 1]?.key || null });
    }).catch(() => setRounds([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [competition]);

  if (!rounds.length) return <p className="text-xs text-slate-500">Calendario non ancora disponibile: il torneo coprirà tutte le giornate.</p>;
  const idx = (k) => rounds.findIndex((r) => r.key === k);
  const bad = start && end && idx(start) > idx(end);
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-3">
        <RoundPick label="Dalla giornata" value={start} rounds={rounds} onChange={(v) => onChange({ start_round: v, end_round: end })} testId={`${testPrefix}-start-round`} />
        <RoundPick label="Alla giornata" value={end} rounds={rounds} onChange={(v) => onChange({ start_round: start, end_round: v })} testId={`${testPrefix}-end-round`} />
      </div>
      {bad && <p className="text-xs text-red-400" data-testid={`${testPrefix}-round-error`}>La giornata finale deve venire dopo quella iniziale</p>}
    </div>
  );
};
